import React from 'react';
import format from 'date-fns/format';

import getDateFNSLocale from 'common/utils/date/getDateFNSLocale';
import HeaderTwoLine from 'common/components/HeaderTwoLine/HeaderTwoLine';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const BusBookingSearchResult = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusBookingSearchResult" */ '../containers/BusBookingSearchResult'),
  loading: DefaultLoadingScreen,
});

const BusBookingSearchResultScreen = props => (
  <BusBookingSearchResult
    {...props}
    goshow={props.navigation.getParam('goshow')}
  />
);

BusBookingSearchResultScreen.navigationOptions = ({ navigation }) => {
  const originLabel = navigation.getParam('originLabel', null);
  const destinationLabel = navigation.getParam('destinationLabel', null);
  const departureDate = navigation.getParam('departureDate', null);

  const headerTitle = originLabel
    ? `${originLabel} → ${destinationLabel}`
    : `Hasil Pencarian`;
  const headerSubtitle = departureDate
    ? format(departureDate, 'dddd, D MMMM YYYY', {
        locale: getDateFNSLocale('id'),
      })
    : '';

  const Header = originLabel ? HeaderTwoLine : HeaderOneLine;

  return {
    headerTitle: <Header title={headerTitle} subtitle={headerSubtitle} />,
  };
};

export default BusBookingSearchResultScreen;
